<div class="login-container">
    <div id="wxlogin-qrcode"></div>
</div>
